import { useMutation, useQuery, UseQueryResult } from '@tanstack/react-query';
import { queryClient } from '.';
import { type Application, type EditApplication } from '../../shared/types';
import { deleteAdminApplication, getAdminApplications, postAdminApplication, putAdminApplication } from '../utilities/api';

export const queryKeys = {
    getAdminApplications: () => ['admin', 'applications', 'get'],
};

export const useAdminApplications = (): UseQueryResult<Application[], Error> => {
    return useQuery({ queryKey: queryKeys.getAdminApplications(), queryFn: getAdminApplications, staleTime: Infinity });
};

export const useUpdateAdminApplication = () => {
    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: EditApplication }) => putAdminApplication(id, data),
        onSuccess: (newApplication: Application) => {
            queryClient.setQueryData(queryKeys.getAdminApplications(), (applications: Application[]) => {
                return applications.map((application) => (application._id === newApplication._id ? newApplication : application));
            });
        },
    });
};

export const useCreateAdminApplication = () => {
    return useMutation({
        mutationFn: (data: EditApplication) => postAdminApplication(data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.getAdminApplications() }),
    });
};

export const useDeleteAdminApplication = () => {
    return useMutation({
        mutationFn: (id: string) => deleteAdminApplication(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.getAdminApplications() });
        },
    });
};
